const observer = new MutationObserver(() => {
  const bundle = document.querySelector('.appstle-bundle');
  if (!bundle) return;
  const priceEls = bundle.querySelectorAll('.ab-bogo-product-price');
  if (priceEls.length < 2) return;
  const allPopulated = [...priceEls].every(el => el.textContent.trim());
  if (!allPopulated) return;
  clearTimeout(timeout);
  observer.disconnect();
  let total = 0;
  priceEls.forEach(el => {
    const discounted = el.querySelector('.ab-bogo-product-original-price');
    const text = discounted
      ? discounted.textContent.trim()
      : el.textContent.trim();
    const value = parseFloat(text.replace(/[^0-9.]/g, ''));
    if (!isNaN(value)) total += value;
  });
  const symbol = '¥';
  const formatted = symbol + total.toLocaleString('ja-JP');
  const target = bundle.querySelector('.ab-bogo-original-price');
  if (target) {
    target.textContent = formatted;
    setTimeout(() => {
      target.textContent = formatted;
    }, 1000)
    setTimeout(() => {
      target.textContent = formatted;
    }, 3000)
    setTimeout(() => {
      target.textContent = formatted;
    }, 10000)
  }
});

const timeout = setTimeout(() => observer.disconnect(), 30000);

function start() {
  observer.observe(document.body, { childList: true, subtree: true });
}
if (document.body) start();
else document.addEventListener('DOMContentLoaded', start);
